// 驗證信箱
export function isEmail(email) {
  const emailRegxp = /[\w-]+@([\w-]+\.)+[\w-]+/;

  return emailRegxp.test(email);
}

export let emailValidate = async (rule, value) => {
  if (value === "") {
    return Promise.reject("請輸入連絡信箱");
  } else {
    if (isEmail(value)) {
      return Promise.resolve();
    } else {
      return Promise.reject("請確認連絡信箱格式");
    }
  }
};
